/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-09-18 17:13:59
 * @LastEditors: caiqin.xie
 * @message: 产品参数-参数表格
 */
import React from "react";
import styles from "../../index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  paramsList: Record<string, any>; // 参数列表
}
interface IParam {
  name: string;
  paramBOs: Record<string, string>[];
}

const ParameterTable = (props:IProps) => {
  const {ctry, words, paramsList} = props
  return (
    <>
      {paramsList && paramsList.length > 0 && (
        <div className={styles['parameter-wrap']}>
          {paramsList.map((item: IParam, index: number) => (
            <div className={styles['parameter-table']} key={index}>
              <div className={styles['parameter-title']}>{item.name}</div>
              <ul className={styles["parameter-list"]}>
                {item.paramBOs && item.paramBOs.map((param, paramIndex) => (
                  <li className={styles["parameter-list-item"]} key={paramIndex}>
                    <span className={styles["list-item-label"]}>{param.name}</span>
                    <span className={styles["list-item-content"]}>{param.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
export default ParameterTable